import { AwsUtil } from './../authentication/aws.service';
import { ServiceRegistry } from './../service/service-registry.service';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { AppConfig } from './../app.config';
import { CognitoUtil } from './../authentication/cognito.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppEnvironment } from './../app-env';
import { BaseRestService } from '../service/base-rest.service';
import * as moment from 'moment';
import {
    UserProfileSingleCurrency,
    UserProfileRiskManager,
    WebApiEndpoints,
    UserProfileMultiEntityNostro,
    ApplicationConfiguration,
    UserProfileType,
    UserProfileALMManager,
    UserProfileALMTrader,
    UserProfileOperations,
    UserProfileReporting,
} from '@liquitics/transaction';
import { Injectable } from '@angular/core';
@Injectable()
export class ApplicationConfigurationService extends BaseRestService<ApplicationConfiguration> {

    constructor(protected http: HttpClient,
        protected awsUtil: AwsUtil,
        protected serviceRegistry: ServiceRegistry,
        protected dashboardEventService: DashboardEventService) {
        super(http, awsUtil, serviceRegistry, dashboardEventService);
    }

    getAPIName(params?: any): string {
        return WebApiEndpoints.QueryApplicationConfigurations;
    }

    useDemoDataFile(): boolean {
        return false;
    }

    getApplicationConfiguration(today: string): Observable<ApplicationConfiguration> {
        return super.getDataObservable({ operatingDate: today }) as Observable<ApplicationConfiguration>;
    }

    getLastAccessedUserProfileIndex(): number {
        const index = window.localStorage.getItem('LiquiticsLastAccessedUserProfileIndex');
        if (!index) {
            return 0;
        } else {
            return parseInt(index, 10);
        }
    }

    saveLastAccessedUserProfileIndex(index: number) {
        window.localStorage.setItem('LiquiticsLastAccessedUserProfileIndex', String(index));
    }

    postResolveData(applicationConfiguration: ApplicationConfiguration, params?: any): ApplicationConfiguration {
        applicationConfiguration.userProfiles = [];

        if (applicationConfiguration.userProfileData) {
            Object.keys(applicationConfiguration.userProfileData)
                .forEach((profileType: UserProfileType) => {
                    const profiles = applicationConfiguration.userProfileData[profileType];
                    profiles.forEach((p) => {
                        if (p.currencies) {
                            p.currencies = p.currencies.split(',');
                        }
                        if (profileType === 'SINGLE_CURRENCY') {
                            const profile = new UserProfileSingleCurrency();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            profile.baseCurrency = profile.currency;
                            applicationConfiguration.userProfiles.push(profile);
                        } else if (profileType === 'MULTI_ENTITY_NOSTRO') {
                            const profile = new UserProfileMultiEntityNostro();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            applicationConfiguration.userProfiles.push(profile);
                        } else if (profileType === 'RISK_MANAGER') {
                            const profile = new UserProfileRiskManager();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            applicationConfiguration.userProfiles.push(profile);
                        } else if (profileType === 'ALM_MANAGER') {
                            const profile = new UserProfileALMManager();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            // TEMP TEMP
                            profile.baseCurrency = profile.currencies[0];
                            applicationConfiguration.userProfiles.push(profile);
                        } else if (profileType === 'ALM_TRADER') {
                            const profile = new UserProfileALMTrader();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            // TEMP TEMP
                            profile.baseCurrency = profile.currencies[0];
                            applicationConfiguration.userProfiles.push(profile);
                        } else if (profileType === 'OPERATIONS') {
                            const profile = new UserProfileOperations();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            applicationConfiguration.userProfiles.push(profile);
                        } else if (profileType === 'REPORTING') {
                            const profile = new UserProfileReporting();
                            Object.keys(p)
                                .forEach((attribute) => {
                                    profile[attribute] = p[attribute];
                                });
                            profile.reportDashboardDesigner = p.reportDashboardDesigner ? true : false;
                            profile.reportDashboardViewer = p.reportDashboardViewer ? true : false;
                            profile.reportDashboardAdmin = p.reportDashboardAdmin ? true : false;
                            applicationConfiguration.userProfiles.push(profile);
                        }
                    });
                });
        }
        return applicationConfiguration;
    }


}

